/*
  Loop Bundles helpers shared by the PDP bundle builder and the cart drawer.

  Loop models the pack as fixed box sizes (3, 6, 9…) and gives every size its
  own discount code, each one the TOTAL discount for that many boxed units
  (6 → 26 €, not 13 + 26). A code applied through /discount/ replaces the one
  before it, so the cart only ever carries the code of the tier it has reached.
  Both the box sizes and the tiers are read live from Loop's storefront API,
  so changing them in Loop needs no theme change.
*/
(function () {
  if (window.clabLoopBundle) return;

  const cache = {};

  // { boxes: [{ id, size }], tiers: [{ code, value, minQty }] }, sorted by
  // size ascending. Falls back to the single box/code the section was
  // configured with when the API cannot be reached.
  function load(cfg) {
    const key = cfg.bundleId;
    if (!cache[key]) {
      const url = cfg.api + '/bundle/' + cfg.bundleId + '?myshopifyDomain=' + encodeURIComponent(cfg.shop);
      cache[key] = fetch(url)
        .then((r) => r.json())
        .then((json) => {
          const data = json && json.data;
          if (!data) throw new Error('no bundle data');
          return {
            boxes: (data.boxSizes || [])
              .map((b) => ({ id: b.id, size: b.minSize }))
              .sort((a, b) => a.size - b.size),
            tiers: (data.discounts || [])
              .map((d) => ({ code: d.code, value: Number(d.value) || 0, minQty: d.minCartQuantity || 0 }))
              .sort((a, b) => a.minQty - b.minQty)
          };
        })
        .catch(() => {
          delete cache[key];
          return {
            boxes: cfg.boxSizeId ? [{ id: cfg.boxSizeId, size: cfg.minQty || 0 }] : [],
            tiers: cfg.discountCode ? [{ code: cfg.discountCode, value: cfg.discountValue || 0, minQty: cfg.minQty || 0 }] : []
          };
        });
    }
    return cache[key];
  }

  // Largest entry whose threshold the unit count reaches, or null.
  function reached(list, units, field) {
    let hit = null;
    list.forEach((x) => { if (units >= x[field]) hit = x; });
    return hit;
  }

  // Units that sit inside Loop boxes — loose extras never count toward a tier.
  async function boxedUnits() {
    const cart = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then((r) => r.json());
    return (cart.items || [])
      .filter((i) => i.properties && i.properties._bundleId)
      .reduce((s, i) => s + i.quantity, 0);
  }

  // Apply the code of the tier the cart's boxed units have reached. Called
  // after anything that changes how many boxes the cart holds.
  async function syncDiscount(cfg) {
    const [{ tiers }, units] = await Promise.all([load(cfg), boxedUnits()]);
    const tier = reached(tiers, units, 'minQty');
    if (tier) await fetch('/discount/' + encodeURIComponent(tier.code), { credentials: 'same-origin' });
    return tier;
  }

  window.clabLoopBundle = { load, reached, boxedUnits, syncDiscount };
})();
